import {
  ACCOUNT_SECURITY_SETUP_INTENT_COOKIE_NAME,
  ACCOUNT_SECURITY_SETUP_INTENT_COOKIE_VALUE,
} from '@/lib/auth/accountSecuritySetupIntent.constants';
import { getSharedSportsFiCookieDomain } from '@/lib/auth/sharedCookieDomain';
import { deleteCookie, setCookie } from '@/lib/utils/cookies';

const accountSecuritySetupIntentMaxAgeSeconds = 15 * 60;

function getBrowserCookieDomain(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return getSharedSportsFiCookieDomain(window.location.hostname);
}

export function markAccountSecuritySetupRequired(): void {
  setCookie(
    ACCOUNT_SECURITY_SETUP_INTENT_COOKIE_NAME,
    ACCOUNT_SECURITY_SETUP_INTENT_COOKIE_VALUE,
    getBrowserCookieDomain(),
    accountSecuritySetupIntentMaxAgeSeconds
  );
}

export function clearAccountSecuritySetupIntent(): void {
  deleteCookie(ACCOUNT_SECURITY_SETUP_INTENT_COOKIE_NAME);
  deleteCookie(ACCOUNT_SECURITY_SETUP_INTENT_COOKIE_NAME, getBrowserCookieDomain());
}
